import {
    ADD_USER_TO_TEAM,
    ADD_USER_TO_TEAM_FAIL,
    ADD_USER_TO_TEAM_SUCCESS,
    REMOVE_USER_FROM_TEAM,
    REMOVE_USER_FROM_TEAM_FAIL,
    REMOVE_USER_FROM_TEAM_SUCCESS,
    UPDATE_USER,
    UPDATE_USER_FAIL,
    UPDATE_USER_SUCCESS
} from './actionTypes';

export const updateUser = ({ userId, details }) => ({
    type: UPDATE_USER,
    payload: { userId, details }
});

export const updateUserSuccess = updatedUser => ({
    type: UPDATE_USER_SUCCESS,
    payload: updatedUser
});

export const updateUserFail = error => ({
    type: UPDATE_USER_FAIL,
    payload: error
});

export const addUserToTeam = ({ userId, teamId }) => ({
    type: ADD_USER_TO_TEAM,
    payload: { userId, teamId }
});
export const addUserToTeamSuccess = user => ({
    type: ADD_USER_TO_TEAM_SUCCESS,
    payload: user
});
export const addUserToTeamFail = error => ({
    type: ADD_USER_TO_TEAM_FAIL,
    payload: error
});
export const removeUserFromTeam = ({ userId, teamId }) => ({
    type: REMOVE_USER_FROM_TEAM,
    payload: { userId, teamId }
});
export const removeUserFromTeamSuccess = user => ({
    type: REMOVE_USER_FROM_TEAM_SUCCESS,
    payload: user
});
export const removeUserFromTeamFail = error => ({
    type: REMOVE_USER_FROM_TEAM_FAIL,
    payload: error
});
